import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un libro físico?',
    a: 'No. Es un recetario digital descargable en formato PDF que puedes ver en cualquier dispositivo.'
  }, {
    q: '¿Cuándo lo recibo?',
    a: 'Inmediatamente después de realizar la compra. Recibirás un enlace de descarga al instante.'
  }, {
    q: '¿Necesito experiencia en cocina?',
    a: 'No. Las recetas están pensadas para principiantes, con instrucciones claras paso a paso.'
  }, {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No, los bonos están incluidos totalmente gratis con tu compra de hoy.'
  }, {
    q: '¿Puedo verlo en mi celular?',
    a: 'Sí, el recetario es compatible con cualquier celular, tablet o computador.'
  }, {
    q: '¿El pago es seguro?',
    a: 'Sí, el pago se procesa a través de una plataforma segura con encriptación SSL. Aceptamos tarjetas de crédito, débito, MercadoPago y transferencia bancaria.'
  }, {
    q: '¿Qué pasa si no me gusta?',
    a: 'Tienes 45 días de garantía total. Si no estás satisfecho con el recetario, te devolvemos el 100% de tu dinero sin hacer preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-[#FEF3E2]" data-id="element-56">
      <div className="max-w-3xl mx-auto" data-id="element-57">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-[#3D2B1F]" data-id="element-58">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-59">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-[#E8D5C4] rounded-xl overflow-hidden transition-all duration-300 shadow-sm" data-id="element-60">
              <button className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-61">
                <span className="font-bold text-lg text-[#3D2B1F] pr-4" data-id="element-62">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-[#D4850A] transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-63" />
              </button>

              <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-64">
                <p className="text-[#6B5344] text-lg" data-id="element-65">{faq.a}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}